import store from "../store/index";
import * as modeTypes from "../store/modules/mode/types";
import * as toolTypes from "../store/modules/tool/types";
import * as touchTypes from "../store/modules/touch/types";
import * as commonTypes from "../store/modules/common/types";
import * as areaTypes from "../store/modules/area/areatype";
import * as canvasTypes from "../store/modules/canvas/canvastypes";
import * as lockType from "../store/modules/lock/types";
import {common} from "../store/modules/common";
import Vue from "vue";


export function isModeTop() {
  return store.state.mode.mode === modeTypes.MODE_TOP;
}
export function isModeTutorial() {
  return store.state.mode.mode === modeTypes.MODE_TUTORIAL;
}
export function isModeTransTutorial() {
  return store.state.mode.modeTransition === modeTypes.MODE_TUTORIAL;
}
export function isModeArea() {
  return store.state.mode.mode === modeTypes.MODE_AREA;
}
export function isModeDraw() {
  return store.state.mode.mode === modeTypes.MODE_DRAW;
}
export function isModePublish() {
  return store.state.mode.mode === modeTypes.MODE_PUBLISH;
}
export function isModeEnd() {
  return store.state.mode.mode === modeTypes.MODE_END;
}

export function isToolSpray() {
  return store.state.tool.tool === 1;
}
export function isToolMarker() {
  return store.state.tool.tool === 2;
}
export function isToolText() {
  return store.state.tool.tool === 3;
}

export function setToolSpray() {
  store.dispatch(toolTypes.namespace + toolTypes.SET_TOOL, 1);
}

export function setToolMarker() {
  store.dispatch(toolTypes.namespace + toolTypes.SET_TOOL, 2);
}

export function setToolText() {
  store.dispatch(toolTypes.namespace + toolTypes.SET_TOOL, 3);
}

export function isTextTransform() {
  return store.state.tool.text.state == toolTypes.TEXT_STATE_TRANSFORM;
}

export function isTextInput() {
  return store.state.tool.text.state != toolTypes.TEXT_STATE_TRANSFORM;
}

export function textInput() {
  return store.dispatch(
    toolTypes.namespace + toolTypes.SET_TEXT_STATE,
    toolTypes.TEXT_STATE_INPUT
  );
}

export function textColor() {
  return store.dispatch(
    toolTypes.namespace + toolTypes.SET_TEXT_STATE,
    toolTypes.TEXT_STATE_COLOR
  );
}

export function textTransform() {
  return store.dispatch(
    toolTypes.namespace + toolTypes.SET_TEXT_STATE,
    toolTypes.TEXT_STATE_TRANSFORM
  );
}

export function textTransMove() {
  return store.dispatch(
    toolTypes.namespace + toolTypes.SET_TEXT_TRANS,
    toolTypes.TEXT_TRANS_MOVE
  );
}

export function textTransScale() {
  return store.dispatch(
    toolTypes.namespace + toolTypes.SET_TEXT_TRANS,
    toolTypes.TEXT_TRANS_SCALE
  );
}

export function textTransRotation() {
  return store.dispatch(
    toolTypes.namespace + toolTypes.SET_TEXT_TRANS,
    toolTypes.TEXT_TRANS_ROTATION
  );
}

export function isTextTransMove() {
  return store.state.tool.text.transState == toolTypes.TEXT_TRANS_MOVE;
}

export function isTextTransScale() {
  return store.state.tool.text.transState == toolTypes.TEXT_TRANS_SCALE;
}

export function isTextTransRotation() {
  return store.state.tool.text.transState == toolTypes.TEXT_TRANS_ROTATION;
}

export function goto(val) {
  store.dispatch(modeTypes.namespace + modeTypes.SET_MODE, val);
}
export function gotoTop() {
  store.dispatch(modeTypes.namespace + modeTypes.SET_MODE, modeTypes.MODE_TOP);
}
export function gotoArea() {
  store.dispatch(modeTypes.namespace + modeTypes.SET_MODE_TRANSITION, modeTypes.MODE_AREA);
}
export function gotoArea2() {
  store.dispatch(modeTypes.namespace + modeTypes.SET_MODE, modeTypes.MODE_AREA);
}
export function gotoTutorial() {
  console.log("gotoTutorial");
  store.dispatch(
    modeTypes.namespace + modeTypes.SET_MODE_TRANSITION,
    modeTypes.MODE_TUTORIAL
  );
}
export function gotoTutorial2() {
  console.log("gotoTutorial2");
  store.dispatch(
    modeTypes.namespace + modeTypes.SET_MODE,
    modeTypes.MODE_TUTORIAL
  );
}
export function gotoDraw() {
  store.dispatch(modeTypes.namespace + modeTypes.SET_MODE, modeTypes.MODE_DRAW);
}
export function gotoPublish() {
  store.dispatch(
    modeTypes.namespace + modeTypes.SET_MODE,
    modeTypes.MODE_PUBLISH
  );
}
export function gotoEnd() {
  store.dispatch(modeTypes.namespace + modeTypes.SET_MODE, modeTypes.MODE_END);
}

export function setStagePos(pos) {
  store.dispatch(touchTypes.namespace + touchTypes.SET_STAGE_POS, pos);
}
export function setMousePos(pos) {
  store.dispatch(touchTypes.namespace + touchTypes.SET_MOUSE_POS, pos);
}

export function showLoading() {
  console.log("Show loading");
  // store.dispatch(commonTypes.namespace + commonTypes.SHOW_LOADING);
  Vue.prototype.$loading.show();
}

export function hideLoading() {
  console.log("Hide Loading");
  // store.dispatch(commonTypes.namespace + commonTypes.HIDE_LOADING);
  Vue.prototype.$loading.hide();
}
export function checkLoading() {
  // console.log("check Loading");
  // Vue.prototype.$loading.check();
}

export function setAreaPos(x, y) {
  store.dispatch(areaTypes.namespace + areaTypes.SET_POS, { x, y });
}

export function setCanvasScale(scale) {
  store.dispatch(canvasTypes.namespace + canvasTypes.SET_SCALE, scale);
}
export function setCanvasOffset(offset) {
  store.dispatch(canvasTypes.namespace + canvasTypes.SET_OFFSET, offset);
}

export function setHasDrawn(flag) {
  store.dispatch(commonTypes.namespace + commonTypes.SET_HAS_DRAWN, flag);
}
export function setContinueDrawing(flag) {
  store.dispatch(
    commonTypes.namespace + commonTypes.SET_CONTINUE_DRAWING,
    flag
  );
}

export function setMyDrawingURL(url) {
  store.dispatch(canvasTypes.namespace + canvasTypes.SET_MY_DRAWING_URL, url);
}

export function isTutorialToolUI() {
  return store.getters["tutorial/isTutorialToolUI"];
}

export function resetTextTool(){
  store.dispatch(toolTypes.namespace + toolTypes.RESET_TEXT_TOOL);
}
export function restoreTexts(texts){
  store.dispatch(toolTypes.namespace + toolTypes.RESTORE_TEXTS, texts);
}

export function setTablet() {
  // store.dispatch(canvasTypes.namespace + canvasTypes.SET_SEND_RES, {width: 2600, height: 1080});
  store.dispatch(canvasTypes.namespace + canvasTypes.SET_SEND_RES, {width: 3840, height: 1080});
  store.dispatch(canvasTypes.namespace + canvasTypes.SET_PIXEL_RATIO, 1);
  store.dispatch(commonTypes.namespace + commonTypes.SET_IS_TABLET, true);
}

export function setSavable(flag) {
  store.dispatch(canvasTypes.namespace + canvasTypes.SET_SAVABLE, flag);
}

export function toFrontAPIDisable() {
  store.dispatch(commonTypes.namespace + commonTypes.SET_TO_FRONT_API_DISABLE);
}
export function setNeedReload(flag = true) {
  store.dispatch(commonTypes.namespace + commonTypes.SET_NEED_RELOAD, flag);
}
export function isNeedReload() {
  return store.state.common.needReload;
}
export function setPage(value) {
  window.scrollTo(0, 0);
  return store.dispatch(commonTypes.namespace + commonTypes.SET_PAGE, value)
}
export function lock(isLock = true) {
  store.dispatch(lockType.namespace + lockType.SET_LOCK, isLock);
}
export function setDrawn(drawn = true) {
  store.dispatch(canvasTypes.namespace + canvasTypes.SET_DRAWN, drawn);
}
